import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";
import {ShareService} from "../../services/share/share.service";

@Component({
    selector: 'app-share-modal',
    templateUrl: './share-modal.component.html',
    styleUrls: ['./share-modal.component.scss'],
    standalone: false
})
export class ShareModalComponent {
  @Input('link') link: string = '';
  @Input('linkGotShared') linkGotShared = new EventEmitter<number>;
  linkCopied: boolean = false;

  constructor(
    private modalController: ModalController,
    private shareService: ShareService
  ) {
  }

  async closeModal(): Promise<void> {
    await this.modalController.dismiss(null, 'cancel');
  }

  async copyLink(){
    if(navigator && navigator.clipboard){
      this.shareService.apiTrackShare().subscribe({complete: () => {}});
      this.linkGotShared.emit(1);
      await navigator.clipboard.writeText(this.link);
      this.linkCopied = true;
    }
  }
}
